module.exports = __webpack_public_path__ + "img/New 글로벌트렌드 이미지.cd3fca96.png";